import { Template } from "./Template";
import { UserMsg } from "./Messages";
import { BrokerConnection } from "./BrokerConnection";
import { StaticsControl } from "./staticsControl";
import { GAConnection } from "./GAConnection";
import { ProfileMenuControl } from "./profile/ProfileMenuControl";
import { AvatarControl } from "./AvatarControl";
import { DfMsg } from "./Messages";
import { EnrolmentController } from "./enrolment/EnrolmentController";
import { LoginController } from "./enrolment/LoginController";
import { EnrolmentExpres } from "./enrolment/EnrolmentExpres";
import { Dictionary } from "./DictionaryControl";
import { SkillsTestController } from "./enrolment/SkillsTestController";
import { DigitalSkillsTestWithEnrolmentController } from "./enrolment/DigitalSkillsTestWithEnrolmentController";
import { DigitalSkillsTestController } from "./enrolment/DigitalSkillsTestController";
import { Validator } from "./Validator";
import { ButtonsControl } from "./ButtonsControl";
import { ProfileServices } from "./profile/ProfileServices";
import { ErrorModal } from "./ErrorMessages";
import { ModalScreen } from "./ModalScreen";
import { textTag } from "./TextTag";
const smoothscroll = require('smoothscroll-polyfill');
import 'nodelist-foreach-polyfill';
smoothscroll.polyfill();
export class ChatControl {
    constructor() {
        var _a, _b, _c, _d;
        this.icons = {};
        this.gaConnection = new GAConnection(this);
        this.messagesQueueWorking = false;
        this.firstTimeOpened = true;
        this.isIE = false || !!document.documentMode;
        this.tInicial = new Date().getTime();
        this.validator = new Validator;
        this.language = this.getLanguage();
        this.userAvatar = StaticsControl.statics.profileIcon;
        this.iduser = '';
        this.userEmail = '';
        this.token = '';
        this.originHost = window.location.origin + window.location.pathname;
        this.showRating = true;
        this.allHardSkills = [];
        this.allSoftSkillsSkills = [];
        this.allDigitalSkillsSkills = [];
        this.userfieldSkills = [];
        this.userSoftSkillsSkills = [];
        this.ButtonsControl = new ButtonsControl;
        this.sendCloseChangePassword = () => {
            const animate = false;
            this.brConnection.sendCustomEvent('cerrar_cambiar_contrasena', null, (botMessages) => {
                this.botResponse(botMessages, animate);
            });
        };
        this.sendCloseEnrolment = () => {
            const animate = false;
            this.brConnection.sendCustomEvent('cerrar_enrolment', null, (botMessages) => {
                this.botResponse(botMessages, animate);
            });
        };
        this.sendNoFieldsEnrolment = (iduser) => {
            const animate = false;
            if (iduser)
                this.sendEndEnrolment(iduser, true);
            this.brConnection.sendCustomEvent('enrolment_sin_ambitos', null, (botMessages) => {
                this.botResponse(botMessages, animate);
            });
        };
        this.isMobile = (() => {
            let check = false;
            (function (a) {
                if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
                    check = true;
            })(navigator.userAgent || navigator.vendor);
            return check;
        })();
        this.channel = this.isMobile ? "web_mobile" : "web_desktop";
        this.initSession = Number(sessionStorage.getItem('init_session'));
        this.setIsOneTrust();
        const cookieGA4 = GA_SESSION_ID[window.location.hostname]
            ? GA_SESSION_ID[window.location.hostname]
            : window.location.hostname.includes('orientador.prefundacion.com')
                ? "_ga_XRXDZXD61K"
                : null;
        this.realSessionId = cookieGA4 ? (_d = (_c = (_b = (_a = document.cookie.split(';')) === null || _a === void 0 ? void 0 : _a.filter(c => c.trim().startsWith(cookieGA4))) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.match(/\.\d+\.(\d+)\./)) === null || _d === void 0 ? void 0 : _d[1] : sessionStorage.getItem('realSessionId');
        this.brConnection = new BrokerConnection(this);
        this.profileServices = new ProfileServices(this);
        this.icons = StaticsControl.statics;
        this.isIE = false || !!document.documentMode;
        this.isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        this.pendingMessagesQueue = [];
        this.brConnection.getToken(() => {
            this.dictionary = new Dictionary(this, () => {
                this._template = new Template(this);
                this.profileMenuControl = new ProfileMenuControl(this);
                this.getReferences();
                this.setListeners();
                setTimeout(() => {
                    this.chatBotMessageWrapper.classList.add('ftcb__msgwrapper--no-animation');
                    this.updateMsgContainerHeight();
                }, 250);
                setTimeout(() => {
                    this.cookiesWindow();
                }, 500);
            });
            this.profileServices.getAllSkills("digital_skills", (err, resp) => {
                this.allDigitalSkillsSkills = resp;
            });
            this.profileServices.getAllSkills("soft_skills", (err, resp) => {
                this.allSoftSkillsSkills = resp;
            });
        });
    }
    setIsOneTrust() {
        const onetrustPages = [
            "www.fundaciontelefonica.com",
            "conectaempleo-formacion.fundaciontelefonica.com",
            "orientador.fundaciontelefonica.com",
            "mapadelempleo.fundaciontelefonica.com",
            "orientador.prefundacion.com",
        ];
        const currentHost = window.location.host;
        const isOneTrustPage = onetrustPages.includes(currentHost);
        this.isOneTrust = isOneTrustPage;
    }
    cookiesWindow() {
        function isMobile() {
            const maxWidth = 768;
            return window.innerWidth <= maxWidth;
        }
        if (this.isOneTrust) {
            document.getElementById('chatBotProfileCookies').style.height = 'auto';
            document.getElementById('chatBotProfileCookies').style.paddingBottom = '0px';
        }
        const cookieFooter = document.getElementById('btn-cookies');
        if (this.isOneTrust) {
            document.getElementById('chatBotProfileCookies').style.display = 'none';
            if (isMobile()) {
                cookieFooter.classList.add("ot-sdk-show-settings");
            }
            else {
                console.log('entra is not mobile');
                document.getElementById('chatBotProfileCookies').style.display = 'flex';
                document.getElementById('btn-cookies').style.display = 'none';
            }
        }
        else {
            cookieFooter.addEventListener("click", function () {
                document.getElementById('chatBotProfileCookies').style.display = 'flex';
                document.getElementById('chatBotProfileCookies').style.bottom = '100px';
            });
        }
    }
    getReferences() {
        this.submitButton = document.querySelector("div#chatbotContainer button#chatBotSubmitButton");
        this.inputTextBox = document.querySelector("div#chatbotContainer div#chatBotInputTextBox");
        this.closeButton = document.querySelector("button#closeChatWindowButton");
        this.chatWindow = document.querySelector('div#chatbotContainer');
        this.avatarControl = new AvatarControl(this);
        this.chatBotMessageWrapper = document.getElementById('chatBotMessageWrapper');
        this.chatBotMsgContainer = document.getElementById('chatBotMsgContainer');
        this.chatBotMsgMenu = document.getElementById('ftcb__avatar__menu');
        this.chatBotMsgMenuBack = document.getElementById('ftcb__avatar__menu-background');
    }
    checkOrigin(event) {
        var actualOrigin = window.location.href;
        var isWhiteListed = false;
        this.brConnection.getCorsWhitelist(window.location.href, (err, response) => {
            if (err == null && response)
                this.showChat(event);
        });
    }
    setListeners() {
        this.submitButton.addEventListener("click", (event) => this.insertMessage(event));
        this.inputTextBox.addEventListener("keydown", (event) => this.insertMessageIntro(event));
        this.inputTextBox.addEventListener("focus", (event) => this.ie11RemovePlaceholder());
        this.inputTextBox.addEventListener("blur", (event) => this.ie11SetPlaceholder());
        this.avatarControl.clickCallback = (event) => {
            this.checkOrigin(event);
        };
        this.closeButton.addEventListener("click", (event) => {
            this.profileMenuControl.closeProfileMenu();
            let header = document.getElementsByClassName("ftcb__header");
            header[0].classList.remove('ftcb__header--open');
            let footer = document.getElementsByClassName("ftcb__inputcontainer");
            footer[0].classList.remove('ftcb__inputcontainer--open');
            setTimeout(() => {
                this.hideChat(event);
            }, 400);
        });
        window.addEventListener('resize', (event) => {
            this.template.scroll();
        });
        this.chatBotMessageWrapper.addEventListener('resize', (event) => {
            this.updateMsgContainerHeight();
        });
    }
    manageUserAvatar() {
        if (this.userAvatar) {
            $("#chatBotMsgContainer .ftcb__avatar__custom").css("background-image", "url('" + this.userAvatar + "')");
            $("#chatBotMsgContainer .ftcb__avatar__custom").show();
        }
        else {
            $("#chatBotMsgContainer .ftcb__avatar__custom").hide();
        }
    }
    menuUserAvatar() {
        if (this.userAvatar) {
            this.chatBotMsgMenu.setAttribute("src", this.userAvatar);
            this.chatBotMsgMenuBack.classList.add("ftcb__avatar__menu--session");
        }
        else {
            if (this.language === 'en-GB') {
                this.chatBotMsgMenu.setAttribute("src", this.icons.profileIconEn);
            }
            else {
                this.chatBotMsgMenu.setAttribute("src", this.icons.profileIcon);
            }
            this.chatBotMsgMenuBack.classList.remove("ftcb__avatar__menu--session");
        }
    }
    sendUserMessage(text) {
        const sendingMsg = new DfMsg(text, this.sessionId, this.language);
        let historyMsg = new UserMsg();
        historyMsg.text = text;
        this.printMessage(historyMsg, true);
        this.brConnection.send(sendingMsg, (botMessages) => this.botResponse(botMessages));
    }
    sendRatingUser(text) {
        const sendingMsg = new DfMsg(text, this.sessionId, this.language);
        this.brConnection.send(sendingMsg, (botMessages) => this.botResponse(botMessages));
    }
    getLanguage() {
        const path = location.pathname.split('/');
        const locale = path[path.length - 1];
        return locale == 'en' ? 'en-GB' : 'es-ES';
    }
    checkCookie() {
        this.brConnection.setSessionId();
        let optanon = this.brConnection.getCookie('OptanonConsent');
        let rgpd = this.brConnection.getCookie('cookie_rgpd');
        if (optanon) {
            optanon = decodeURIComponent(optanon);
            if (optanon.includes('C0004:0')) {
                $('#chatBotProfileCookies').show();
                $('#chatBotProfileCookies .ftcb__msg__btn').hide();
            }
            else {
                $('#chatBotProfileCookies').hide();
            }
        }
        else {
            if (rgpd != '1') {
                $('#chatBotProfileCookies').show();
            }
        }
    }
    insertMessage(event) {
        this.checkCookie();
        let value = this.inputTextBox.textContent;
        if (this.trim(value).length == 0) {
            return;
        }
        value = value.replace(/[`~@#$%^&*()_|+\-=;:'",.<>\{\}\[\]\\\/]/gi, ' ');
        this.inputTextBox.contentEditable = 'false';
        this.inputTextBox.setAttribute("placeholder", "");
        this.inputTextBox.innerHTML = '';
        this.sendUserMessage(value);
    }
    insertMessageIntro(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            this.insertMessage(event);
        }
    }
    ie11RemovePlaceholder() {
        if (this.isIE) {
            this.inputTextBox.setAttribute("placeholder", "");
        }
    }
    ie11SetPlaceholder() {
        if (this.isIE && this.inputTextBox.textContent.length === 0) {
            this.inputTextBox.setAttribute("placeholder", "Preguntame algo...");
        }
    }
    botResponse(botMessages, animate = true) {
        botMessages[0].order = 'first';
        if (botMessages.length > 1) {
            for (let i = (botMessages.length - 1); i > 0; i--) {
                if (botMessages[i].type === 'BOT_MSG') {
                    botMessages[i].order = 'last';
                    break;
                }
            }
        }
        let lapse = botMessages.length * 2000;
        let input = this.inputTextBox;
        let that = this;
        setTimeout(function () {
            input.contentEditable = 'true';
            if (!that.isMobile)
                input.focus();
        }, lapse);
        for (let i = 0; i < botMessages.length; i++) {
            const botMsg = botMessages[i];
            setTimeout(() => {
                this.printMessage(botMsg, animate);
            }, botMsg.delay);
        }
    }
    acceptedCookies() {
        let optanon = this.brConnection.getCookie('OptanonConsent');
        let rgpd = this.brConnection.getCookie('cookie_rgpd');
        if (rgpd == '1')
            return true;
        if (optanon) {
            optanon = decodeURIComponent(optanon);
            if (optanon.includes('C0004:1'))
                return true;
        }
    }
    controlCookiesMsg() {
        var actualOrigin = window.location.href;
        let optanon = this.brConnection.getCookie('OptanonConsent');
        let rgpd = this.brConnection.getCookie('cookie_rgpd');
        if (actualOrigin.includes(WEBAPP_HOST) && optanon) {
            optanon = decodeURIComponent(optanon);
            if (optanon.includes('C0004:1'))
                $('#chatBotProfileCookies').hide();
        }
        if (rgpd == '1')
            $('#chatBotProfileCookies').hide();
        $('#chatBotProfileCookies .btn-cookies_accept').click((evt) => {
            $('#chatBotProfileCookies').hide();
            $('#chatBotProfileMenu')
                .addClass('ftcb__profile--close')
                .removeClass('ftcb__profile--open');
            this.brConnection.setCookie('cookie_rgpd', '1', 365);
        });
        $('#chatBotProfileCookies .btn-cookies_decline').click((evt) => {
            $('div#chatBotProfileCookies span').html(textTag(this.dictionary.texts.bot, 'Cookies_text_2'));
            this.brConnection.setCookie('cookie_rgpd', '0', 365);
            document.getElementById('chatBotProfileCookies').style.height = 'auto';
        });
    }
    openChatWindow(event, animate = true) {
        if (event) {
            event.stopPropagation();
        }
        setTimeout(() => {
            let header = document.getElementsByClassName("ftcb__header");
            header[0].classList.add('ftcb__header--open');
            let footer = document.getElementsByClassName("ftcb__inputcontainer");
            footer[0].classList.add('ftcb__inputcontainer--open');
        }, 500);
        this.chatWindow.classList.add('ftcb__box--open');
        this.chatWindow.classList.remove('ftcb__box--close');
        this.chatWindow.style.display = "block";
        this.updateMsgContainerHeight();
        this.chatBotMessageWrapper.classList.add('ftcb__msgwrapper--no-animation');
        if (animate) {
            setTimeout(() => {
                this.avatarControl.hide();
                this.updateMsgContainerHeight();
            }, 500);
        }
        else {
            this.avatarControl.hide();
        }
        if (this.firstTimeOpened) {
            const animate = false;
            this.firstTimeOpened = false;
            this.brConnection.init((botMessages) => {
                this.botResponse(botMessages, animate);
            });
        }
        this.template.scroll();
        this.controlCookiesMsg();
        this.checkCookie();
        this.brConnection.setSessionId();
        setInterval(() => {
            let optanon = this.brConnection.getCookie('OptanonConsent');
            this.checkCookie();
            this.brConnection.setSessionId();
            this.brConnection.checkAcceptedCookies();
        }, 500);
    }
    showChat(event, animate = true) {
        this.openChatWindow(event, animate);
    }
    closeSession() {
        this.userEmail = '';
        this.token = '';
        this.iduser = '';
        this.userAvatar = '';
        this.menuUserAvatar();
    }
    startEnrolment() {
        this.Enrolment = new EnrolmentController(this, (err) => {
            if (err)
                return this.sendCloseEnrolment();
            this.sendEndEnrolment(this.iduser, false);
        });
        this.Enrolment.start();
    }
    startSkillsTest(callback) {
        this.SkillsTest = new SkillsTestController(this, callback);
        this.SkillsTest.start();
    }
    startDigitalSkillsTestWithEnrolment() {
        this.DigitalSkillsTestWithEnrolment = new DigitalSkillsTestWithEnrolmentController(this, (err) => {
            if (err)
                return this.sendCloseEnrolment();
            this.sendEndDigitalSkillsTest(this.iduser, false);
        });
        this.DigitalSkillsTestWithEnrolment.start();
    }
    startDigitalSkillsTest() {
        this.DigitalSkillsTest = new DigitalSkillsTestController(this, (err) => {
            if (err)
                return this.sendCloseEnrolment();
            this.sendEndDigitalSkillsTest(this.iduser, false);
        });
        this.DigitalSkillsTest.start();
    }
    startEnrolmentExpres(callback) {
        this.EnrolmentExpres = new EnrolmentExpres(this, callback);
        this.EnrolmentExpres.start();
    }
    messageSentModal(callback) {
        new ModalScreen({
            title: textTag(this.dictionary.texts.modals, 'MessageSent_title'),
            subtitle: textTag(this.dictionary.texts.modals, 'MessageSent_subtitle'),
            primaryButton: { text: textTag(this.dictionary.texts.modals, 'Aceptar'), callback: callback },
        });
    }
    errorModal(callback) {
        new ErrorModal(this, callback);
    }
    startLoginExpres(callback) {
        this.Login = new LoginController(this, callback);
        this.Login.start();
    }
    sendEndEnrolment(iduser, express) {
        const animate = false;
        const parameters = {
            idUser: iduser,
            express: express,
            action: 'enrolment'
        };
        this.brConnection.sendCustomEvent('user', parameters, (botMessages) => {
            this.botResponse(botMessages, animate);
        });
    }
    sendEndDigitalSkillsTest(iduser, express) {
        const animate = false;
        const parameters = {
            idUser: iduser,
            express: express,
            digitalSkillsTest: true
        };
        this.brConnection.sendCustomEvent('digitalSkills', parameters, (botMessages) => {
            this.botResponse(botMessages, animate);
        });
    }
    sendCloseCardCursos() {
        const animate = false;
        this.brConnection.sendCustomEvent('cerrar_card_cursos', null, (botMessages) => {
            this.botResponse(botMessages, animate);
        });
    }
    startLogin() {
        this.Login = new LoginController(this, (err) => {
            if (err)
                return this.sendCloseLogin();
            this.sendEndLogin(this.iduser, false);
        });
        this.Login.start();
    }
    recoverPassword() {
        this.Login = new LoginController(this, (err) => {
            if (err)
                return this.sendCloseChangePassword();
            this.sendEndLogin(this.iduser, false);
        });
        this.Login.start();
        this.Login.startRecover(this.Login.executeNext);
    }
    sendEndLogin(iduser, express) {
        const animate = false;
        this.menuUserAvatar();
        const parameters = {
            idUser: iduser,
            express: express,
            action: 'login'
        };
        this.brConnection.sendCustomEvent('user', parameters, (botMessages) => {
            this.botResponse(botMessages, animate);
        });
    }
    sendCloseLogin() {
        const animate = false;
        this.brConnection.sendCustomEvent('cerrar_login', null, (botMessages) => {
            this.botResponse(botMessages, animate);
        });
    }
    sendSkillsTestEnd(iduser) {
        const animate = false;
        const parameters = {
            idUser: iduser,
            express: false,
            action: 'test'
        };
        this.brConnection.sendCustomEvent('user', parameters, (botMessages) => {
            this.botResponse(botMessages, animate);
        });
    }
    sendUnsuscribeUser() {
        const animate = false;
        this.brConnection.sendCustomEvent('baja_user', null, (botMessages) => {
            this.botResponse(botMessages, animate);
        });
    }
    sendUserButtonMessage(text, animate = true) {
        this.checkCookie();
        let msg = new DfMsg(text, this.sessionId, this.language);
        this.brConnection.send(msg, (botMessages) => {
            this.botResponse(botMessages, animate);
        });
    }
    hideChat(event) {
        document.querySelector('.ftcb__box').classList.add('ftcb__box--close');
        document.querySelector('.ftcb__box').classList.remove('ftcb__box--open');
        setTimeout(() => {
            this.chatWindow.style.display = "none";
            this.avatarControl.show();
        }, 500);
    }
    printMessage(message, animate, callback = null) {
        if (animate) {
            this.chatBotMessageWrapper.classList.remove('ftcb__msgwrapper--no-animation');
        }
        else {
            this.chatBotMessageWrapper.classList.add('ftcb__msgwrapper--no-animation');
        }
        this.pendingMessagesQueue.push(message);
        if (!this.messagesQueueWorking) {
            this.messagesQueueWorking = true;
            setTimeout(() => {
                this.processQueueMessages.bind(this)(animate, callback);
            });
        }
    }
    processQueueMessages(animate, callback = null) {
        let tempDelay = animate ? 1700 : 0;
        if (this.pendingMessagesQueue.length > 0) {
            this.template.printMessage(this.pendingMessagesQueue.shift(), animate);
            if (this.pendingMessagesQueue.length == 0) {
                this.messagesQueueWorking = false;
                this.manageUserAvatar();
                if (callback) {
                    callback(null);
                }
            }
            else {
                setTimeout(() => {
                    this.processQueueMessages.bind(this)(animate, callback);
                }, tempDelay);
            }
        }
        else {
            this.messagesQueueWorking = false;
            this.chatBotMessageWrapper.classList.remove('ftcb__msgwrapper--no-animation');
            if (callback) {
                callback(null);
            }
        }
    }
    trim(str) {
        return str.replace(/^[\s]+/, '').replace(/[\s]+$/, '');
    }
    get template() {
        return this._template;
    }
    updateMsgContainerHeight() {
        let h = this.chatBotMessageWrapper.offsetHeight;
        document.getElementById('chatBotMsgContainer').style.height = (h - 15) + "px";
    }
    parse(str) {
        if (!str || str.length == 0) {
            return null;
        }
        if (this.isIE) {
            let a = str;
            return eval("(" + a + ')');
        }
        else {
            return JSON.parse(str);
        }
    }
}
